<template>
  <div :class="['Announcement', variant]" @click="$emit('click')">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Announcement',
  props: {
    variant: {
      type: String,
      default: 'purple',
      validator(value) {
        return ['purple', 'green', 'orange'].includes(value)
      },
    },
  },
  emits: ['click'],
}
</script>

<style lang="scss">
.Announcement {
  border-radius: 16px;
  display: inline-flex;
  justify-content: center;
  align-items: flex-start;
  flex-shrink: 0;
  cursor: pointer;

  &.purple {
    background: linear-gradient(180deg, #d8d8f2 0%, #edeef4 100%);
  }

  &.green {
    background: linear-gradient(90deg, #d8f2d8 0%, #edf4ee 100%);
  }

  &.orange {
    background: linear-gradient(90deg, #ffe1c2 0%, #ffe8e1 100%);
  }
}
</style>
